import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DataContext } from '../App';

function RegionMap() {
  const { t } = useTranslation('translation', {keyPrefix: 'regionMap'});
  const data = React.useContext(DataContext);
  const backgroundStyle = { backgroundImage: "url(/"+data.map+".png)"};
  const myStyle = {alignItems: "center",  bottom: 0, height: "78px", paddingRight: 0, position: 'absolute'};

  const [isVisible, setVisible] = useState("false");
  const ToggleMap = () => {
      setVisible(!isVisible); 
  };

  return (
    <div className="container-fluid">
        <div className={isVisible ? "row" : "row full"} id="mapcontainer" style={backgroundStyle}>
            <div className="mapoverlay"></div>
            <Row style={myStyle}>
                <Col>
                    <h3 className="font-weight-bold text-black fs-30 mb-0">{data.region_name}</h3>
                </Col>
                <Col>
                    <Button id='viewmap' variant='outline-primary' onClick={ToggleMap}>{t(isVisible ? "view" : "hide")}</Button>
                </Col>
            </Row>
        </div>
    </div>
  );
}

export default RegionMap;